module.exports = __webpack_public_path__ + "img/bg26.d6ea8aee.png";